import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3462a38e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderTabs" }
const _hoisted_2 = { class: "FTLOrderTabs__container" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.id,
          class: _normalizeClass(["container__tab", { 'tab--active': _ctx.isTabSelected(tab) }]),
          onClick: ($event: any) => (_ctx.selectTab(tab))
        }, _toDisplayString(tab.name), 11, _hoisted_3))
      }), 128))
    ])
  ]))
}